export const AUTHENTICATE_REQUEST = 'AUTHENTICATE_REQUEST';

export const authenticateRequest = (username: string, password: string) => ({
    type: AUTHENTICATE_REQUEST,
    payload: { username, password },
});
